import React, { PureComponent } from 'react';
import TablaRow from './TablaRow'
import TablaRowEdicion from './TablaRowEdicion'

class TablaBody extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { ingresoCobranza, cobranzas, confirmarCobranza, denegarCobranza, editar, eliminarCobranza, expandirRow, rowSeleccionada, permisosUsuario } = this.props;

        let cobranzasRow = [];
        if (cobranzas.length > 0) {
            cobranzas.map((cobranza, index) => {

                let claseFlecha = rowSeleccionada == cobranza.Id ? "clickable none-text-decoration glyphicon glyphicon-triangle-top" : "clickable none-text-decoration glyphicon glyphicon-triangle-bottom"

                cobranzasRow.push(
                    <TablaRow ingresoCobranza={ingresoCobranza}
                        cobranza={cobranza}                 
                        expandirRow={expandirRow}
                        claseFlecha={claseFlecha}
                        confirmarCobranza={confirmarCobranza}
                        denegarCobranza={denegarCobranza}
                        editar={editar}
                        eliminarCobranza={eliminarCobranza}
						permisosUsuario={permisosUsuario}
						/>
                );

                if (rowSeleccionada != undefined && rowSeleccionada == cobranza.Id) {
                    cobranzasRow.push(
                        <TablaRowEdicion cobranza={cobranza} />
                    );
                }
            });
        }

        return (
            <tbody>
                {cobranzasRow}
            </tbody>);
    }
}

export default TablaBody;